/* ==========================================================================
Modal
========================================================================== */

"use strict";

function modal_open(modalID) {
  $("#" + modalID).addClass("is-active");
  if ($("#" + modalID + " .modal-background").length) {
    $("#" + modalID + " .modal-background").addClass("scaleInCircle");
  }
  $("#" + modalID + " .modal-content").addClass("scaleIn");
  $("#" + modalID + " .modal-close").removeClass("is-hidden");
  //Prevent sticky fixed nav and backtotop from overlapping modal
  $("#scrollnav, #backtotop").addClass("is-hidden");
  //Prevent body from scrolling when scrolling inside modal
  setTimeout(function () {
    if ($(".dashboard-wrapper").length) {
      $("body").addClass("is-fixed");
    }
  }, 700);
}

function modal_close(modalID) {
  if ($("#" + modalID + " .modal-background").length) {
    $("#" + modalID + " .modal-background").removeClass("scaleInCircle");
  }
  $("#" + modalID + " .modal-content").removeClass("scaleIn");
  $("#" + modalID + " .modal-close").addClass("is-hidden");
  //Restore native body scroll
  if ($(".dashboard-wrapper").length) {
    $("body").removeClass("is-fixed");
  }
  setTimeout(function () {
    $(".modal.is-active").removeClass("is-active");
    //Restore sticky nav and backktotop
    $("#scrollnav, #backtotop").removeClass("is-hidden");
  }, 500);
}

function initModals() {
  //main variable
  var modalID;

  //Triggering a modal
  $(document).on("click", ".modal-trigger", function () {
    modalID = $(this).attr("data-modal");
    modal_open(modalID);
  });

  //Closing a modal
  $(document).on("click", ".modal-close, .modal-dismiss", function () {
    modal_close(modalID);
  });

  //Modal user select toggle
  $(document).on("click", ".modal-card-body .card-select i", function () {
    $(this).toggleClass("is-active");
    $(this).closest(".flex-card").toggleClass("is-active");
    $(".save-btn").removeClass("is-disabled");
  });

  //Modal image gallery with slick carousel
  $(document).on("click", ".modal-trigger.gallery-trigger", function () {
    //Prevents carousel from initiating on a non loaded image
    setTimeout(function () {
      $(".slick-gallery").slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
        autoplay: true,
        infinite: false,
      });
    }, 100);
  });

  //Success message modal
  if ($("#success-icon").length) {
    var resetSuccess = $("#success-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".success-trigger", function () {
      setTimeout(function () {
        new Vivus("success-icon", {
          type: "oneByOne",
          duration: 60,
          delay: 300,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/success.svg",
        });
      }, 300);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#success-icon svg").replaceWith(resetSuccess);
    });
  }
  //Error message modal
  if ($("#error-icon").length) {
    var resetError = $("#error-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".error-trigger", function () {
      setTimeout(function () {
        new Vivus("error-icon", {
          type: "oneByOne",
          duration: 60,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/error.svg",
        });
      }, 300);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#error-icon svg").replaceWith(resetError);
    });
  }
  //Warning message modal
  if ($("#warning-icon").length) {
    var resetWarning = $("#warning-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".warning-trigger", function () {
      setTimeout(function () {
        new Vivus("warning-icon", {
          type: "oneByOne",
          duration: 60,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/warning.svg",
        });
      }, 300);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#warning-icon svg").replaceWith(resetWarning);
    });
  }
  //Info message modal
  if ($("#info-icon").length) {
    var resetInfo = $("#info-icon svg"); //declare element to reset it at modal close
    //trigger svg animation
    $(document).on("click", ".info-trigger", function () {
      setTimeout(function () {
        new Vivus("info-icon", {
          type: "oneByOne",
          duration: 60,
          animTimingFunction: Vivus.EASE_OUT_BOUNCE,
          selfDestroy: true,
          file: "assets/img/graphics/icons/modals/info.svg",
        });
      }, 1000);
    });
    //Reset element with initial clone
    $(document).on("click", ".modal-close, .modal-dismiss", function () {
      $("#info-icon svg").replaceWith(resetInfo);
    });
  }
}
